import nebulaLogo from "../assets/nebula-logo.png";
import LoginForm from "./LoginForm";

export default function LandingPage() {
    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-950 via-black to-gray-900 text-white relative overflow-hidden" data-testid="landing-page">
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                <img
                    src={nebulaLogo}
                    alt="Nebula"
                    className="max-w-lg sm:max-w-5xl lg:max-w-6xl opacity-80 drop-shadow-[0_0_45px_rgba(124,58,237,0.6)]"
                    data-testid="landing-logo"
                />
            </div>
            <div className="relative z-10 p-6 sm:p-10">
                <div className="max-w-sm bg-gray-900/85 border border-purple-500/40 rounded-2xl shadow-2xl backdrop-blur px-6 py-5" data-testid="landing-login-card">
                    <div className="mb-4">
                        <p className="text-xs uppercase tracking-[0.3em] text-purple-300">Nebula Systems</p>
                        <h2 className="text-2xl font-bold text-white mt-1">
                            Access the Command Deck
                        </h2>
                        <p className="text-sm text-gray-300 mt-1">
                            Authorized operators only.
                        </p>
                    </div>
                    <LoginForm />
                </div>
            </div>
        </div>
    );
}
